import { PerkStatus } from "src/views/sponsor/perks/types";

export type PerkStatusTooltipContent = {
  title: string;
  description: string;
};

export const PERK_STATUS_TOOLTIPS: Record<
  PerkStatus,
  PerkStatusTooltipContent
> = {
  [PerkStatus.NOT_STARTED]: {
    title: "What is a 'Not Started' perk?",
    description: "You haven't started your perk submission yet.",
  },
  [PerkStatus.INCOMPLETE]: {
    title: "What is an 'Incomplete' perk?",
    description:
      "You've started providing info for your perk submission but haven't submitted it for our review yet.",
  },
  [PerkStatus.SUBMITTED]: {
    title: "What is an 'Under Review' perk?",
    description:
      "We're reviewing your submitted perk to make sure we have everything needed.",
  },
  [PerkStatus.APPROVED]: {
    title: "What is an 'Approved' perk?",
    description:
      "Your perk submission has been accepted and the Hack the North team is working on executing it!",
  },
  [PerkStatus.COMPLETED]: {
    title: "What is a 'Completed' perk?",
    description:
      "Your perk has been completely fulfilled by the Hack the North team.",
  },
};

export const getPerkStatusTooltip = (
  status: PerkStatus
): PerkStatusTooltipContent => PERK_STATUS_TOOLTIPS[status];
